import { MarketplaceProductTypeEnum } from '@ria-client/supergraph/marketplace/constants';
import RecapListSection, { type RecapListProps } from './RecapListSection';

export type RecapListWrapperProps = {
  isGeoTargeted: boolean;
  marketplaceProductType?: MarketplaceProductTypeEnum;
} & RecapListProps;

function GeoRecapList(props: RecapListProps) {
  // ponytail: geo region wiring deferred until a Tailwind GeoProvider exists (NWA-3990 territory); not storied, no baseline.
  return <RecapListSection {...props} />;
}

export function RecapListWrapper({ isGeoTargeted, ...props }: RecapListWrapperProps) {
  return isGeoTargeted ? <GeoRecapList {...props} /> : <RecapListSection {...props} />;
}
